/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FavoriteList } from '../../models/favorite-list';

export interface FavoriteGetList$Params {
}

export function favoriteGetList(http: HttpClient, rootUrl: string, params?: FavoriteGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<FavoriteList>> {
  const rb = new RequestBuilder(rootUrl, favoriteGetList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FavoriteList>;
    })
  );
}

favoriteGetList.PATH = '/favorite/list';
